<template>
  <div class="project-header" v-bind:class="{'project-header--is-editing': this.isEditing}" v-on:keyup.enter="createTodo">
    <div class="project-header__title">{{ this.project.title }}</div>
    <a class="project-header__repo-name" v-show="this.project.githubUrl.length > 0" :href="this.project.githubUrl" target="_blank">{{ this.project.githubUrl | github }} </a>
    <div class="project-header__input project-header__input--title">
      <input placeholder="Todo Title" v-model="todoTitle" name="title" type="text">
    </div>
    <div class="project-header__input project-header__input--issue">
    <input placeholder="Issue #" v-model="issueNo" name="issueNo" type="text">
    </div>
    <div class="project-header__button-submit" v-on:click="createTodo">Add New Todo »</div>
    <IconPlusSign class="project-header__button-toggle" v-bind:isActive="this.isEditing" v-on:click.native="toggleEditing" />
  </div>
</template>

<script>
import IconPlusSign from "@/components/icons/IconPlusSign.vue";

const githubFilter = value => {
  return value.substr(value.lastIndexOf("/") + 1);
};
export default {
  mounted() {},
  filters: {
    github: githubFilter
  },
  props: ["project"],
  data() {
    return {
      todoTitle: "",
      issueNo: "",
      isEditing: false
    };
  },
  components: {
    IconPlusSign
  },
  methods: {
    toggleEditing() {
      this.isEditing = !this.isEditing;
    },
    createTodo() {
      const title = this.todoTitle;
      const issueNo = this.issueNo;
      if (title.length > 0) {
        this.$emit("create-todo", {
          title,
          issueNo,
          isEditing: false,
          isDone: false
        });
      }
      this.todoTitle = "";
      this.issueNo = "";
    }
  }
};
</script>

<style lang="scss">
.project-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    "title . button-toggle"
    "repo-name . ."
    "input-title input-title input-title"
    "input-issue input-issue input-issue"
    "button-submit button-submit button-submit";
  grid-gap: 10px;
  align-items: baseline;
  max-width: 100%;
  margin-bottom: 25px;

  @include screen(desktop) {
    grid-template-columns: auto 1fr auto auto auto;
    grid-template-areas:
      "title repo-name input-title input-issue button-toggle"
      ". . . button-submit .";
  }
  &__title {
    font-size: 32px;
    font-weight: 700;
    grid-area: "title";
    align-self: baseline;
  }
  &__repo-name {
    font-size: 14px;
    font-weight: 700;
    grid-area: repo-name;
    align-self: baseline;
    justify-self: start;
    text-decoration: none;
    color: $mono-53;
  }
  &__input {
    position: relative;
    display: grid;
    visibility: hidden;
    height: 0;
    transition: opacity 0.2s ease, height 0.2s ease;
    opacity: 0;
    color: $mono-100;
    border-bottom: 1px solid $mono-100;
    background: $mono-0;

    @include screen(desktop) {
      height: auto;
      .project-header--is-editing & {
        height: auto;
      }
    }
    .project-header--is-editing & {
      visibility: visible;
      height: 28px;
      opacity: 1;
    }
    &--title {
      grid-area: input-title;
    }
    &--issue {
      grid-area: input-issue;
    }
    &:focus-within {
      &:after {
        transform: scaleX(1);
      }
    }
    > input {
      all: unset;
      padding: 5px 0;
    }
    &:after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      content: "";
      transition: all 0.2s ease;
      transform: scaleX(0);
      transform-origin: 0 50%;
      border-bottom: 2px solid $mono-100;
    }
  }
  &__button-submit {
    font-size: 12px;
    font-weight: 500;
    visibility: hidden;
    grid-area: button-submit;
    justify-self: end;
    height: 0;
    cursor: pointer;
    transition: opacity 0.2s ease, height 0.2s ease;
    text-align: right;
    letter-spacing: 4.29px;
    text-transform: uppercase;
    opacity: 0;
    color: $mono-100;

    @include screen(desktop) {
      height: auto;
      .project-header--is-editing & {
        height: auto;
      }
    }
    .project-header--is-editing & {
      visibility: visible;
      height: auto;
      opacity: 1;
    }
  }
  &__button-toggle {
    @include icon-size(24px);
    grid-area: button-toggle;
    align-self: end;
    justify-self: end;
    cursor: pointer;
    user-select: none;
    fill: $mono-100;
  }
}
</style>
